import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "va_admin_token";
const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const setHeader = (token) => {
  if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete axios.defaults.headers.common.Authorization;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);      // null = checking, false = anon, obj = authed
  const [token, setToken] = useState(localStorage.getItem(KEY));

  useEffect(() => {
    if (!token) { setUser(false); return; }
    setHeader(token);
    axios.get(`${API}/auth/me`)
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(KEY); setHeader(null); setToken(null); setUser(false); });
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(KEY, data.token);
    setHeader(data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setHeader(null);
    setToken(null);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};
